export default [
    {
      reducerKey: 'tickets',
      sagaKey: 'ticketsListSaga',
      importReducer: () => import(/* webpackChunkName: "domain-tickets" */ 'modules/Tickets/List/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-tickets" */ 'modules/Tickets/List/store/saga'),
    },
    {
      reducerKey: 'ticket',
      sagaKey: 'ticketSaga',
      importReducer: () => import(/* webpackChunkName: "domain-tickets" */ 'modules/Tickets/Chat/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-tickets" */ 'modules/Tickets/Chat/store/saga'),
    },
]
